import NotificationApi from './rest/NotificationApi';

export default new NotificationApi();
